<template>
<div class="container-fluid">
    <el-container>
        <el-header height="15%">
            <div class="row mt-4">
                <div class="col-md-2">
                    <h4>Заявки на звонок</h4>
                </div>
            </div>
        </el-header>
        <el-main height="80%">
            <el-form aria-label="Поиск" >
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="Поиск по телефону">
                            <el-col :span="14">
                                <el-input v-model="query.phone" @change="getRequests()"></el-input>
                            </el-col>

                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="Сортировка">
                            <el-select
                            v-model="query.sort"
                            :width="300"
                            no-data-text="Нет данных"
                            @change="getRequests()">
                                <el-option
                                v-for="(item, index) in sortConfig"
                                :key="index"
                                :value="item.field"
                                :label="item.title"
                                
                                />                                
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>


            </el-form>
            <el-table
                    :data="requests"
                    style="width: 100%"
                    empty-text="Нет данных">
                <el-table-column
                        prop="id"
                        label="Id"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="fio"
                        label="Имя"
                />
                <el-table-column
                        prop="phone"
                        label="Телефон"
                />
                <el-table-column
                  prop="created_at"
                  label="Дата создания заказа"
                >
                  <template #default="scope">
                    {{ getHumanDate(scope.row.created_at) }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="comment"
                  label="Комментарий"
                />

                <el-table-column
                        fixed="right"
                        label="Действия"
                        width="400">
                    <template slot-scope="scope">
                        <el-button
                          size="mini"
                          type="danger"
                          @click.native.prevent="deleteRow(scope.$index)">Удалить</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>
        <el-footer height="5%">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="paginator.total"
              :current-page.sync="paginator.current_page"
              @current-change="getPage(paginator.current_page)"
              :hide-on-single-page="true"
              :page-size="paginator.per_page"
              :page-count="paginator.last_page"
            >
            </el-pagination>
        </el-footer>
    </el-container>
</div>
</template>

<script>
import axios from "axios";
import sortConfig from '../composable/config/request-call-sort.config'
import { SETPRELOADER_STATE } from '@/store/mutation-types'

export default {
    name: "RequestCalls",
    data: function (){
      return{
        requests: [],
        paginator: [],
        query:{
            sort: sortConfig[0].field,
            phone:''
        },
        current: 0,
        sortConfig
      }
    },
    mounted(){
        this.getRequests();
    },

    computed: {
      activeSort() {
        const result = this.sortConfig.find((e) => e.field === this.query.sort)
        return result ? result.options  : undefined
      },
      queryComputed() {
        const sort = this.activeSort
        const q = this.query.phone
        const result = {}
        let isChange = false;
        if (sort) {
            isChange = true
            result['sort'] = sort;
        }
        if (q) {
            isChange = true
            result['q']=q
        }
        return isChange ? result : undefined
      }
    },

    methods:{
        getQuery(query) {
          const qs = require('qs');
          let q
          if (query) {
            q = query
          } else {
            q = this.queryComputed ? `?${qs.stringify(this.queryComputed)}` : ''
          }
          return q;
        },
        async getRequests(query){
          const q = this.getQuery(query)
          this.$store.commit(SETPRELOADER_STATE, true)
            axios.get('request-call'  + q).then((response)=>{
               this.paginator = response.data.meta;
               this.requests = response.data.data;
            })
            .catch((errors)=>{
              if(errors.response.status === 401){
                this.$router.push('/login');
              }
            })
            .finally(() => this.$store.commit(SETPRELOADER_STATE, false));
        },

        getPage: function(pageNum){
          const qs = require('qs');
          const qProps = this.queryComputed ? `&${qs.stringify(this.activeSort)}` : undefined
          const q = `?page=${pageNum}${qProps}`
          this.getRequests(q)
        },
        getHumanDate(value){
            const date = new Date(value)
            if (date) {
                const  options = { year: 'numeric', month: 'short', day: 'numeric' };
                const result = date.toLocaleDateString('ru-Ru', options)
                return result 
            }
            return ''
        },
        deleteRow: function (index) {
            let id = this.requests[index].id;

            axios.delete('/request-call/'+id).then(()=>{                
                this.getRequests()
                .then(() => this.$notify.success('Звонок удален'));
            }).catch((errors)=>{
                if(errors.response.status === 401){
                    this.$router.push('/login');
                }
            });

        },
    }
}
</script>

<style scoped>

</style>